import React from "react";
import { experienceImage } from "../mock";

export default function Experience() {
  return (
    <section id="experience" className="relative bg-neutral-950 text-[#fbf3e4] py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div className="order-2 lg:order-1">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={experienceImage} alt="Chef at work" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="order-1 lg:order-2">
          <p className="text-xs tracking-[0.4em] text-neutral-400 mb-4">MY EXPERIENCE</p>
          <h3 className="font-display text-4xl md:text-6xl leading-[1] mb-8">
            15+ Years in the Kitchen
          </h3>
          <p className="text-neutral-300 text-lg leading-relaxed mb-5">
            For over 15 years, I've worked in professional kitchens across Türkiye and the UK, gaining experience in
            everything from busy bistros and smokehouses to Rosette-awarded restaurants.
          </p>
          <p className="text-neutral-300 text-lg leading-relaxed">
            Over the years, I've developed skills not only in cooking but also in butchery, menu development, kitchen
            management, and front-of-house operations. Every kitchen has shaped my style and strengthened my passion
            for creating honest, flavour-driven food using quality ingredients.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            <Stat number="15+" label="YEARS" />
            <Stat number="200+" label="EVENTS" />
            <Stat number="5★" label="STANDARD" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-display text-4xl">{number}</div>
      <div className="text-xs tracking-[0.2em] text-neutral-400 mt-2">{label}</div>
    </div>
  );
}
